import React from "react";
import { Button, Form, PageHeader, Space, Typography } from "antd";
import moment from "moment";
import useVarsayilanDeger from "../../hooks/useVarsayilanDeger";
import {
  tutariYuzdeyeCevir,
  yuzdeHesala,
} from "../../utils/faturaSatirHesaplama";
import { FileAddOutlined, SaveOutlined } from "@ant-design/icons";

import TeklifSiparisHeader from "./TeklifSiparisHeader";
import TeklifSiparisSatir from "./TeklifSiparisSatir";
import TeklifSiparisFooter from "./TeklifSiparisFooter";

const { Text } = Typography;

const formSize = "middle";

function TeklifSiparisLayout({
  title = "-",
  saveButtonTitle = "-",
  saveButtonLoading = false,
  form,
  onFinish,
  tip,
}) {
  const { getDefaultSetting } = useVarsayilanDeger();

  const onValuesChange = (changedValues, allValues) => {
    if (changedValues.dovizId !== undefined) {
      form.setFieldsValue({
        kasaId: undefined,
        bankaHesapId: undefined,
      });
    }
    if (changedValues.stopajOran !== undefined) {
      setTeklifSiparisFooterFields();
    }
    if (changedValues.tevkifatOran !== undefined) {
      setTeklifSiparisFooterFields();
    }

    if (
      changedValues.araIskontoTip !== undefined ||
      changedValues.araIskontoDeger !== undefined
    ) {
      setTeklifSiparisFooterFields();
    }
  };

  const setTeklifSiparisFooterFields = () => {
    const fields = form.getFieldsValue();
    const {
      teklifSiparisSatir,
      araIskontoDeger = 0,
      araIskontoTip = "yuzde",
      stopajOran = 0,
      tevkifatOran = 0,
    } = fields;
    const teklifSiparisSatirNoHidden = teklifSiparisSatir.filter(
      (x) => x.hidden === false
    );

    const araToplam = teklifSiparisSatirNoHidden.reduce(
      (toplam, item) => (toplam += parseFloat(item.birimFiyat * item.miktar)),
      0
    );
    const toplamSatirIskontoTutar = teklifSiparisSatirNoHidden.reduce(
      (toplam, item) => (toplam += parseFloat(item.iskontoTutar)),
      0
    );

    const araIskontoTutar =
      araIskontoTip === "tutar"
        ? parseFloat(araIskontoDeger)
        : yuzdeHesala(araToplam - toplamSatirIskontoTutar, araIskontoDeger);

    const araIskontoOran =
      araIskontoTip === "yuzde"
        ? parseFloat(araIskontoDeger)
        : tutariYuzdeyeCevir(
            araIskontoDeger,
            araToplam - toplamSatirIskontoTutar
          );

    const brutToplam = parseFloat(
      araToplam - toplamSatirIskontoTutar - araIskontoTutar
    );

    const stopajTutar = yuzdeHesala(brutToplam, stopajOran);

    let toplamOtvTutar = teklifSiparisSatirNoHidden.reduce(
      (toplam, item) => (toplam += parseFloat(item.otvTutar)),
      0
    );
    toplamOtvTutar -= yuzdeHesala(toplamOtvTutar, araIskontoOran);

    let toplamKdv01Tutar = teklifSiparisSatirNoHidden.reduce(
      (toplam, item) =>
        item.kdvOran === 1 ? (toplam += item.kdvTutar) : (toplam += 0),
      0
    );
    toplamKdv01Tutar -= yuzdeHesala(toplamKdv01Tutar, araIskontoOran);

    let toplamKdv08Tutar = teklifSiparisSatirNoHidden.reduce(
      (toplam, item) =>
        item.kdvOran === 8 ? (toplam += item.kdvTutar) : (toplam += 0),
      0
    );
    toplamKdv08Tutar -= yuzdeHesala(toplamKdv08Tutar, araIskontoOran);

    let toplamKdv18Tutar = teklifSiparisSatirNoHidden.reduce(
      (toplam, item) =>
        item.kdvOran === 18 ? (toplam += item.kdvTutar) : (toplam += 0),
      0
    );
    toplamKdv18Tutar -= yuzdeHesala(toplamKdv18Tutar, araIskontoOran);

    const toplamKdvTutar = parseFloat(
      toplamKdv01Tutar + toplamKdv08Tutar + toplamKdv18Tutar
    );

    const tevkifatTutar = yuzdeHesala(toplamKdvTutar, parseFloat(tevkifatOran));

    const genelToplamTutar = parseFloat(
      araToplam -
        toplamSatirIskontoTutar -
        araIskontoTutar -
        stopajTutar +
        toplamKdvTutar +
        toplamOtvTutar -
        tevkifatTutar
    );

    form.setFields([
      { name: "araIskontoTutar", value: araIskontoTutar },
      { name: "araIskontoOran", value: araIskontoOran },
      { name: "araToplamTutar", value: araToplam },
      { name: "toplamSatirIskontoTutar", value: toplamSatirIskontoTutar },
      { name: "brutToplamTutar", value: brutToplam },
      { name: "stopajTutar", value: stopajTutar },
      { name: "toplamOtvTutar", value: toplamOtvTutar },
      { name: "toplamKdv01Tutar", value: toplamKdv01Tutar },
      { name: "toplamKdv08Tutar", value: toplamKdv08Tutar },
      { name: "toplamKdv18Tutar", value: toplamKdv18Tutar },
      { name: "toplamKdvTutar", value: toplamKdvTutar },
      { name: "tevkifatTutar", value: tevkifatTutar },
      { name: "genelToplamTutar", value: genelToplamTutar },
    ]);
  };

  const firstOnFinish = (values) => {
    onFinish(values);
  };

  return (
    <div>
      <PageHeader
        title={
          <Text style={{ fontSize: 22 }}>
            <FileAddOutlined /> {title}
          </Text>
        }
        extra={
          <Button
            icon={<SaveOutlined />}
            type="primary"
            title="Kaydet"
            size="large"
            form="myForm"
            htmlType="submit"
            loading={saveButtonLoading}
          >
            {saveButtonTitle}
          </Button>
        }
        style={{ padding: 0, paddingBottom: 18 }}
      />
      <Form
        id="myForm"
        size={formSize}
        labelCol={{ span: 6 }}
        labelAlign="left"
        form={form}
        onValuesChange={onValuesChange}
        initialValues={{
          teklifSiparisTip: null,
          duzenlemeTarihi: moment(),
          gecerlilikTarihi: moment(),
          dovizId: getDefaultSetting("doviz"),
          evrakNo: "",
          teklifSiparisSatir: [
            {
              stokId: null,
              stokVaryantGrupId: null,
              stokBirimId: null,
              stokDepoId: getDefaultSetting("stokDepo"),
              urunAdi: "",
              aciklama: "",
              miktar: 1,
              birimFiyat: 0,
              barkod: "",
              otvTutar: 0,
              otvOran: 0,
              kdvTutar: 0,
              kdvOran: 0,
              toplam: 0,
              iskontoOran: 0,
              iskontoTip: "yuzde",
              iskontoTutar: 0,
            },
          ],
          araToplamTutar: 0,
          toplamSatirIskontoTutar: 0,
          araIskontoDeger: 0,
          araIskontoOran: 0,
          araIskontoTip: "yuzde",
          araIskontoTutar: 0,
          brutToplamTutar: 0,
          stopajOran: 0,
          stopajTutar: 0,
          toplamOtvTutar: 0,
          toplamKdv01Tutar: 0,
          toplamKdv08Tutar: 0,
          toplamKdv18Tutar: 0,
          toplamKdvTutar: 0,
          tevkifatOran: 0,
          tevkifatTutar: 0,
          genelToplamTutar: 0,
        }}
        onFinish={firstOnFinish}
      >
        <Space direction="vertical" style={{ width: "100%" }} size="large">
          <TeklifSiparisHeader form={form} tip={tip} />
          <TeklifSiparisSatir
            form={form}
            setFooterFields={setTeklifSiparisFooterFields}
          />
          <TeklifSiparisFooter
            form={form}
            setFooterFields={setTeklifSiparisFooterFields}
          />
        </Space>
        <Form.Item name="teklifSiparisTip" initialValue={null} hidden noStyle />
      </Form>
    </div>
  );
}

export default TeklifSiparisLayout;
